import '@splidejs/splide/css';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Global functions
import Project from './global-functions';
import initGalleryLighbox from './components/_lightbox-gallery';
import initAnimation from './animation-classes';
import 'lazysizes';

import lightGallery from 'lightgallery';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-zoom.css';

import lgThumbnail from 'lightgallery/plugins/thumbnail';


Project.ready(() => {
    initGalleryLighbox().init();
    initAnimation();

    // AOS initialization
    AOS.init({
        duration: 1000,
        // once: true,
        easing: 'ease-in-out',
        offset: -30,
    });

    const gallery = document.getElementById('gallery');
    if (gallery) {
        lightGallery(gallery, {
            selector: 'a',
            plugins: [lgThumbnail],
            speed: 500,
            download: true,
            appendCounterTo: '.lg-components',
            thumbWidth: 152,
            thumbHeight: '101px',
            alignThumbnails: 'middle',
            exThumbImage: 'data-src',
            preload: 1,
            mobileSettings: {
                controls: false,
                download: false,
                thumbnail: false,
                zoom: false,
                swipe: false
            }
        });

        gallery.addEventListener('lgAfterOpen', () => {
            const downloadBtn = document.querySelector('.lg-download');
            const closeBtn = document.querySelector('.lg-close');
            const lgContent = document.querySelector('.lg-inner');

            if (downloadBtn && lgContent) {
                const downloadLabel = gallery.getAttribute('download-label');
                downloadBtn.textContent = downloadLabel || '';
                lgContent.appendChild(downloadBtn);
            }

            if (closeBtn) {
                const closeLabel = gallery.getAttribute('close-label');
                closeBtn.textContent = closeLabel || '';
            }
        });


        const items = gallery.querySelectorAll('.gallery-item');
        items.forEach((item, index) => {
            if (index >= 5) item.style.display = 'none';
        });
    }

    document.addEventListener('click', function (e) {
        const target = e.target;
        if (target.tagName === 'BUTTON' || target.tagName === 'A') {
            target.blur();
        }
    });

});
